import integerWithCommas from '../../../shared/utils/integerWithCommas';
import styles from '../report.module.scss';
import {
  getEnrolledNewCountForMembership,
  getEnrolledRenewCountForMembership,
} from '../services';

export default function MembershipDetails({ product, isPayByUser }: any) {
  return (
    <div className="d-flex justify-content-between">
      <div className="d-block">
        <div className={`${styles.commonStyles}`}>Available</div>
        <div className={styles.valueStyles}>
          {isPayByUser ? (
            <span>&#8734;</span>
          ) : (
            integerWithCommas(product.quantityNotRedeemed)
          )}
        </div>
      </div>
      <div className="d-block">
        <div className={`${styles.commonStyles}`}>Enrolled:New</div>
        <div className={styles.valueStyles}>
          {integerWithCommas(getEnrolledNewCountForMembership(product))}
        </div>
      </div>
      <div className="d-block">
        <div className={`${styles.commonStyles}`}>Enrolled:Renew</div>
        <div className={styles.valueStyles}>
          {integerWithCommas(getEnrolledRenewCountForMembership(product))}
        </div>
      </div>
    </div>
  );
}
